export default __webpack_public_path__ + "resources/icons/d142-008d.webp";